(() => {
  const selector = '[data-seasee-promotions]';
  const ticketIcon = '<svg viewBox="0 0 24 24" fill="none"><path d="M4 9.25V6.5A2.5 2.5 0 0 1 6.5 4h11A2.5 2.5 0 0 1 20 6.5v2.75a2.75 2.75 0 0 0 0 5.5v2.75a2.5 2.5 0 0 1-2.5 2.5h-11A2.5 2.5 0 0 1 4 17.5v-2.75a2.75 2.75 0 0 0 0-5.5Z"/><path d="M12 7.5v9"/></svg>';
  const calendarIcon = '<svg viewBox="0 0 24 24" fill="none"><path d="M7 3v3M17 3v3M4.5 9h15M6.5 5h11A2.5 2.5 0 0 1 20 7.5v10A2.5 2.5 0 0 1 17.5 20h-11A2.5 2.5 0 0 1 4 17.5v-10A2.5 2.5 0 0 1 6.5 5Z"/></svg>';
  const chevronIcon = '<svg class="seasee-promotions__tab-chevron" viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="m7.5 4.5 5 5.5-5 5.5"/></svg>';

  function hydrateBlockPromos(root) {
    if (root.dataset.promoSource !== 'blocks') return;
    const tabsContainer = root.querySelector('[data-promo-tabs]');
    const panelsContainer = root.querySelector('[data-promo-panels]');
    const dialog = root.querySelector('[data-promo-dialog]');
    const previews = [...root.querySelectorAll('[data-promo-open][data-promo-source-id]')];
    if (!tabsContainer || !panelsContainer || !dialog || tabsContainer.children.length > 0) return;

    previews.forEach((preview, index) => {
      const sourceId = preview.dataset.promoSourceId;
      const title = preview.dataset.promoTitle || 'Promo SEASEE';
      const badge = preview.dataset.promoBadge || 'PROMO';
      const summary = preview.dataset.promoSummary || '';
      const validity = preview.dataset.promoValidity || summary;
      const code = preview.dataset.promoCode || '';
      const cta = preview.dataset.promoCta || 'Salin kode';
      const termsTemplate = root.querySelector(`template[data-promo-terms-template="${CSS.escape(sourceId)}"]`);

      preview.dataset.promoIndex = String(index);
      preview.setAttribute('aria-controls', dialog.id);

      const tab = document.createElement('button');
      tab.type = 'button';
      tab.className = `seasee-promotions__tab${index === 0 ? ' is-active' : ''}`;
      tab.id = `${root.id}-tab-${index}`;
      tab.setAttribute('role', 'tab');
      tab.setAttribute('aria-selected', String(index === 0));
      tab.setAttribute('aria-controls', `${root.id}-panel-${index}`);
      tab.tabIndex = index === 0 ? 0 : -1;
      tab.dataset.promoTab = String(index);
      const tabIcon = document.createElement('span');
      tabIcon.className = 'seasee-promotions__tab-icon';
      tabIcon.setAttribute('aria-hidden', 'true');
      tabIcon.innerHTML = ticketIcon;
      const tabCopy = document.createElement('span');
      tabCopy.className = 'seasee-promotions__tab-copy';
      if (badge) { const small = document.createElement('small'); small.textContent = badge; tabCopy.appendChild(small); }
      const strong = document.createElement('strong'); strong.textContent = title; tabCopy.appendChild(strong);
      if (summary) { const span = document.createElement('span'); span.textContent = summary; tabCopy.appendChild(span); }
      tab.append(tabIcon, tabCopy);
      tab.insertAdjacentHTML('beforeend', chevronIcon);
      tabsContainer.appendChild(tab);

      const panel = document.createElement('article');
      panel.className = `seasee-promotions__panel${index === 0 ? ' is-active' : ''}`;
      panel.id = `${root.id}-panel-${index}`;
      panel.setAttribute('role', 'tabpanel');
      panel.setAttribute('aria-labelledby', tab.id);
      panel.tabIndex = 0;
      panel.dataset.promoPanel = String(index);
      panel.hidden = index !== 0;

      const top = document.createElement('div');
      top.className = 'seasee-promotions__panel-top';
      const topIcon = document.createElement('span');
      topIcon.className = 'seasee-promotions__panel-icon';
      topIcon.setAttribute('aria-hidden', 'true');
      topIcon.innerHTML = calendarIcon;
      const topCopy = document.createElement('div');
      const validityLabel = document.createElement('p'); validityLabel.textContent = 'Periode promo';
      const validityValue = document.createElement('strong'); validityValue.textContent = validity;
      topCopy.append(validityLabel, validityValue); top.append(topIcon, topCopy);

      const heading = document.createElement('h3'); heading.textContent = title;
      const termsHeading = document.createElement('h4'); termsHeading.textContent = 'Syarat & Ketentuan';
      const terms = document.createElement('div'); terms.className = 'seasee-promotions__terms rte';
      if (termsTemplate) terms.appendChild(termsTemplate.content.cloneNode(true));
      else { const p = document.createElement('p'); p.textContent = 'Ketentuan promo belum ditambahkan.'; terms.appendChild(p); }
      panel.append(top, heading, termsHeading, terms);

      if (code) {
        const voucher = document.createElement('div'); voucher.className = 'seasee-promotions__voucher';
        const voucherCopy = document.createElement('div');
        const voucherLabel = document.createElement('span'); voucherLabel.textContent = 'Kode promo';
        const voucherCode = document.createElement('code'); voucherCode.textContent = code;
        voucherCopy.append(voucherLabel, voucherCode);
        const copyButton = document.createElement('button'); copyButton.type = 'button';
        copyButton.dataset.copyCode = code; copyButton.dataset.copyDefault = cta; copyButton.dataset.copySuccess = 'Kode tersalin';
        const copyLabel = document.createElement('span'); copyLabel.textContent = cta; copyButton.appendChild(copyLabel);
        voucher.append(voucherCopy, copyButton); panel.appendChild(voucher);
      }
      panelsContainer.appendChild(panel);
    });

    const count = root.querySelector('[data-promo-count]');
    if (count) count.textContent = `${previews.length} promo`;
  }

  function initialize(root) {
    if (!root || root.dataset.promoInitialized === 'true') return;
    hydrateBlockPromos(root);

    const dialog = root.querySelector('[data-promo-dialog]');
    const openButtons = [...root.querySelectorAll('[data-promo-open]')];
    const closeButton = root.querySelector('[data-promo-close]');
    const tabs = [...root.querySelectorAll('[data-promo-tab]')];
    const panels = [...root.querySelectorAll('[data-promo-panel]')];
    const previewTrack = root.querySelector('[data-promo-preview-track]');
    const slideButtons = [...root.querySelectorAll('[data-promo-slide]')];
    if (!dialog || openButtons.length === 0 || !closeButton || tabs.length === 0) return;
    root.dataset.promoInitialized = 'true';
    let lastTrigger = openButtons[0];

    const activate = (index, focusTab = false) => {
      const targetIndex = String(index);
      tabs.forEach((tab) => {
        const active = tab.dataset.promoTab === targetIndex;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
        if (active && focusTab) tab.focus();
      });
      panels.forEach((panel) => {
        const active = panel.dataset.promoPanel === targetIndex;
        panel.classList.toggle('is-active', active);
        panel.hidden = !active;
      });
    };

    const openDialog = (index, trigger) => {
      lastTrigger = trigger || openButtons[0]; activate(index || 0);
      if (typeof dialog.showModal === 'function' && !dialog.open) dialog.showModal(); else dialog.setAttribute('open', '');
      closeButton.focus();
    };
    const closeDialog = () => {
      if (typeof dialog.close === 'function' && dialog.open) dialog.close(); else dialog.removeAttribute('open');
      lastTrigger?.focus();
    };

    openButtons.forEach((button, index) => {
      if (!button.dataset.promoIndex) button.dataset.promoIndex = String(index);
      button.addEventListener('click', () => openDialog(button.dataset.promoIndex, button));
    });
    closeButton.addEventListener('click', closeDialog);
    dialog.addEventListener('click', (event) => { if (event.target === dialog) closeDialog(); });
    dialog.addEventListener('cancel', (event) => { event.preventDefault(); closeDialog(); });

    tabs.forEach((tab, tabIndex) => {
      tab.addEventListener('click', () => activate(tab.dataset.promoTab));
      tab.addEventListener('keydown', (event) => {
        if (!['ArrowDown', 'ArrowUp', 'ArrowRight', 'ArrowLeft', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault(); let nextIndex = tabIndex;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = tabs.length - 1;
        if (event.key === 'ArrowDown' || event.key === 'ArrowRight') nextIndex = (tabIndex + 1) % tabs.length;
        if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') nextIndex = (tabIndex - 1 + tabs.length) % tabs.length;
        activate(tabs[nextIndex].dataset.promoTab, true);
      });
    });

    const updateSliderControls = () => {
      if (!previewTrack || slideButtons.length === 0) return;
      const maxScroll = Math.max(0, previewTrack.scrollWidth - previewTrack.clientWidth);
      slideButtons.forEach((button) => {
        const previous = button.dataset.promoSlide === 'previous';
        button.disabled = previous ? previewTrack.scrollLeft <= 2 : previewTrack.scrollLeft >= maxScroll - 2;
      });
    };
    slideButtons.forEach((button) => button.addEventListener('click', () => {
      const card = previewTrack?.querySelector('[data-promo-open]');
      if (!previewTrack || !card) return;
      const gap = Number.parseFloat(getComputedStyle(previewTrack).gap) || 10;
      const step = card.getBoundingClientRect().width + gap;
      previewTrack.scrollBy({ left: button.dataset.promoSlide === 'previous' ? -step : step, behavior: 'smooth' });
    }));
    previewTrack?.addEventListener('scroll', updateSliderControls, { passive: true }); updateSliderControls();

    root.querySelectorAll('[data-copy-code]').forEach((button) => button.addEventListener('click', async () => {
      const code = button.dataset.copyCode; const label = button.querySelector('span'); if (!code || !label) return;
      try {
        if (navigator.clipboard && window.isSecureContext) await navigator.clipboard.writeText(code);
        else { const textarea = document.createElement('textarea'); textarea.value = code; textarea.setAttribute('readonly', ''); textarea.style.cssText = 'position:fixed;opacity:0'; document.body.appendChild(textarea); textarea.select(); document.execCommand('copy'); textarea.remove(); }
        label.textContent = button.dataset.copySuccess; button.classList.add('is-copied');
        window.setTimeout(() => { label.textContent = button.dataset.copyDefault; button.classList.remove('is-copied'); }, 2200);
      } catch (error) { console.warn('SEASEE promotion code could not be copied.', error); }
    }));
  }

  const initializeAll = (scope = document) => { if (scope.matches?.(selector)) initialize(scope); scope.querySelectorAll?.(selector).forEach(initialize); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeAll()); else initializeAll();
  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  document.addEventListener('shopify:block:select', (event) => {
    const root = event.target.closest?.(selector); if (!root) return; initialize(root);
    const preview = event.target.closest?.('[data-promo-open]'); if (preview) preview.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
  });
})();
